module.exports = __webpack_public_path__ + "img/as.9b95df9b.svg";